module.exports = __webpack_public_path__ + "img/img-main-bg00M.8737689b.png";